import React, { Component } from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { loadCart } from "../../../services/cart/actions";
import { updateCart } from "../../../services/total/actions";
import { getSavedCarts, saveCart, deleteCart } from "../../../services/cartPersistence";
import { formatPrice } from "../../helpers/formatPrice";
import BackWithSearch from "../../Mobile/Elements/BackWithSearch";
import Meta from "../../helpers/meta";
import withRouter from "../../../withRouter";

const computeTotal = (products) =>
	products.reduce((sum, p) => {
		const base = parseFloat(p.price) || 0;
		const qty = p.quantity || 1;
		const addons = (p.selectedaddons || []).reduce((s, a) => s + (parseFloat(a.price) || 0), 0);
		return sum + (base + addons) * qty;
	}, 0);

class SavedCarts extends Component {
	state = { carts: {} };

	componentDidMount() {
		// Flush the active cart to persistence before rendering the list
		const { cartProducts } = this.props;
		const restaurantId = localStorage.getItem("activeRestaurant");
		if (restaurantId && cartProducts.length > 0) {
			saveCart(
				restaurantId,
				localStorage.getItem("activeRestaurantSlug") || "",
				localStorage.getItem("activeRestaurantName") || "",
				localStorage.getItem("activeRestaurantImage") || "",
				cartProducts
			);
		}
		this.setState({ carts: getSavedCarts() });
	}

	handleDelete = (e, restaurantId) => {
		e.stopPropagation();
		deleteCart(restaurantId);

		// If deleting the active cart, also wipe it from Redux and localStorage
		const activeRestaurantId = Number(localStorage.getItem("activeRestaurant"));
		if (restaurantId === activeRestaurantId) {
			this.props.loadCart([]);
			this.props.updateCart([]);
			localStorage.removeItem("activeRestaurant");
			localStorage.removeItem("activeRestaurantSlug");
			localStorage.removeItem("activeRestaurantName");
			localStorage.removeItem("activeRestaurantImage");
		}

		this.setState({ carts: getSavedCarts() });
	};

	handleNavigate = (cart) => {
		this.props.navigate(`/stores/${cart.slug}`);
	};

	// Go to cart review page (totals, delivery, coupon) — not directly to payment
	handleOpenCart = (e, cart) => {
		e.stopPropagation();
		const { cartProducts, navigate } = this.props;
		const activeRestaurantId = Number(localStorage.getItem("activeRestaurant"));
		if (cart.restaurantId === activeRestaurantId && cartProducts.length > 0) {
			navigate("/cart");
		} else {
			// load saved cart into redux then go to cart review
			this.props.loadCart(cart.products);
			this.props.updateCart(cart.products);
			localStorage.setItem("activeRestaurant", cart.restaurantId);
			localStorage.setItem("activeRestaurantSlug", cart.slug || "");
			localStorage.setItem("activeRestaurantName", cart.name || "");
			localStorage.setItem("activeRestaurantImage", cart.image || "");
			navigate("/cart");
		}
	};

	_renderPrice(cart) {
		const total = computeTotal(cart.products);
		const align = localStorage.getItem("currencySymbolAlign");
		const symbol = localStorage.getItem("currencyFormat") || "";
		return (
			<span>
				{align === "left" && symbol}
				{formatPrice(total)}
				{align === "right" && symbol}
			</span>
		);
	}

	render() {
		if (window.innerWidth > 768) {
			return <Navigate to="/" />;
		}

		const { carts } = this.state;
		const activeRestaurantId = Number(localStorage.getItem("activeRestaurant"));
		const entries = Object.values(carts).sort((a, b) => b.updatedAt - a.updatedAt);

		return (
			<React.Fragment>
				<Meta
					seotitle={localStorage.getItem("cartPageTitle")}
					seodescription={localStorage.getItem("seoMetaDescription")}
					ogtype="website"
					ogtitle={localStorage.getItem("seoOgTitle")}
					ogdescription={localStorage.getItem("seoOgDescription")}
					ogurl={window.location.href}
					twittertitle={localStorage.getItem("seoTwitterTitle")}
					twitterdescription={localStorage.getItem("seoTwitterDescription")}
				/>
				<BackWithSearch
					boxshadow={true}
					has_title={true}
					title={localStorage.getItem("cartPageTitle")}
					disable_search={true}
					homeButton={true}
					goto_store={false}
				/>

				{!entries.length ? (
					<div className="cart-empty-block bg-white">
						<div className="d-flex justify-content-center">
							<img
								className="cart-empty-img"
								src="/assets/img/various/cart-empty.png"
								alt={localStorage.getItem("cartEmptyText")}
							/>
						</div>
						<h2 className="cart-empty-text mt-50 text-center">
							{localStorage.getItem("cartEmptyText")}
						</h2>
					</div>
				) : (
					<div className="saved-carts-page">
						{entries.map((cart) => {
							const isActive = cart.restaurantId === activeRestaurantId;
							const itemCount = cart.products.reduce((s, p) => s + (p.quantity || 1), 0);
							return (
								<div
									key={cart.restaurantId}
									className={`saved-cart-card${isActive ? " saved-cart-card--active" : ""}`}
									onClick={() => this.handleNavigate(cart)}
								>
									{cart.image ? (
										<img src={cart.image} alt={cart.name} className="saved-cart-card-img" />
									) : (
										<div className="saved-cart-card-img saved-cart-card-img--placeholder">
											<i className="si si-basket" />
										</div>
									)}
									<div className="saved-cart-card-body">
										<div className="saved-cart-card-name">{cart.name}</div>
										<div className="saved-cart-card-meta">
											<span>
												{itemCount} {localStorage.getItem("floatCartItemsText")}
											</span>
											<span className="px-2">&nbsp;|&nbsp;</span>
											{this._renderPrice(cart)}
										</div>
									</div>
									<div className="saved-cart-card-actions" onClick={(e) => e.stopPropagation()}>
										<button
											className="saved-cart-checkout-btn"
											style={{ backgroundColor: localStorage.getItem("storeColor") }}
											onClick={(e) => this.handleOpenCart(e, cart)}
										>
											{localStorage.getItem("floatCartViewCartText") || "View Cart"}{" "}
											<i className="si si-basket" />
										</button>
										<button
											className="saved-cart-delete-btn"
											onClick={(e) => this.handleDelete(e, cart.restaurantId)}
											aria-label="Remove"
										>
											&times;
										</button>
									</div>
								</div>
							);
						})}
					</div>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	cartProducts: state.cart.products,
});

export default withRouter(
	connect(mapStateToProps, { loadCart, updateCart })(SavedCarts)
);
